import { FunctionComponent, useContext, useEffect } from 'react';

import { SearchCriteriaContext } from 'stores/contexts';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { TargetingEvent } from './types';

export const MesoTargeting: FunctionComponent = () => {
  const searchCriteria: SearchCriteriaModel = useContext(SearchCriteriaContext);

  if (!(window && searchCriteria)) {
    return null;
  }

  window.meso = window.meso || {};
  window.meso.targeting = window.meso.targeting || [];

  useEffect(() => {
    const { regionId, startDate, endDate, adults, children, star, amenities, lodging, origin } = searchCriteria;
    const targetingEvent: TargetingEvent = {
      type: 'update',
      targeting: {
        dest: regionId,
        dateEnd: endDate,
        dateStart: startDate,
        adults,
        kids: children,
        locResolver: 'gaia',
        origin,
        ha: amenities !== undefined ? amenities.toString() : '',
        hpt: lodging !== undefined ? lodging.toString() : '',
        sr: (star && star.toString()) || '',
      },
    };

    window.meso.targeting.push(targetingEvent);
  });

  return null;
};
